export const DOMAIN_RECOMMENDATIONS = "RECOMMENDATIONS";
